<mat-card appearance="outlined" class="mat-card-recording_info_vital">

  <div style="display: flex; flex-direction: column; height: 100%;">

    <mat-card-header>
      <mat-card-title i18n="@@home.vitalRecording.title.protocol">プロトコル</mat-card-title>
      <mat-card-subtitle>{{ this.recordData?.data.recordTypeView}}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content class="protocol-detail">
      <div class="detail-area-row">
        <!-- <div fxFlex="33.33">
        <div class="data-details-title">計測時間（HH:MM:SS）</div>
        <div class="data-details-value">{{ this.recordData?.data.totalTime }}</div>
      </div> -->
        <div class="detail-items">
          <!-- <div class="data-details-title">Max temperature</div> -->
          <div class="data-details-title" i18n="@@home.vitalRecording.label.maxTemperature">最大　検温値</div>
          <div class="data-details-value">
            <span>{{ this.recordData?.data.temperatureMax | number:'1.2-2' }}</span>
            <span>°C</span>
          </div>
        </div>
        <div class="detail-items">
          <div class="data-details-title" i18n="@@home.vitalRecording.label.avgTemperature">平均　検温値</div>
          <div class="data-details-value">
            <span>{{ this.recordData?.data.temperatureAvg | number:'1.2-2' }}</span>
            <span>°C</span>
          </div>
        </div>
      </div>

      <div class="detail-area-row">
        <div class="detail-items">
          <div class="data-details-title">脈拍数　平均値</div>
          <div class="data-details-value">
            <span>{{ this.recordData?.data.hrAvg | number:'1.2-2' }}</span>
            <span> BPM</span>
          </div>
        </div>
        <div class="detail-items">
          <div class="data-details-title">脈拍数　最大値</div>
          <div class="data-details-value">
            <span>{{ this.recordData?.data.hrMax | number:'1.2-2' }}</span>
            <span> BPM</span>
          </div>
        </div>
        <div class="detail-items">
          <div class="data-details-title">脈拍数　最小値</div>
          <div class="data-details-value">
            <span>{{ this.recordData?.data.hrMin | number:'1.2-2' }}</span>
            <span> BPM</span>
          </div>
        </div>
      </div>

      <div class="detail-area-row">
        <div class="detail-items">
          <div class="data-details-title" i18n="@@home.vitalRecording.label.avgNeckSpo2">頸部SpO2　平均値</div>
          <div class="data-details-value">
            <span>{{ this.recordData?.data.spo2Avg | number:'1.2-2' }}</span>
            <span>%</span>
          </div>
        </div>
        <div class="detail-items">
          <div class="data-details-title" i18n="@@home.vitalRecording.label.maxNeckSpo2">頸部SpO2　最大値</div>
          <div class="data-details-value">
            <span>{{ this.recordData?.data.spo2Max | number:'1.2-2' }}</span>
            <span>%</span>
          </div>
        </div>
        <div class="detail-items">
          <div class="data-details-title" i18n="@@home.vitalRecording.label.minNeckSpo2">頸部SpO2　最小値</div>
          <div class="data-details-value">
            <span>{{ this.recordData?.data.spo2Min | number:'1.2-2' }}</span>
            <span>%</span>
          </div>
        </div>
      </div>

      <div class="detail-area-row">
        <div class="detail-items">
          <div class="data-details-title" i18n="@@home.vitalRecording.label.avgFingerSpo2">指先SpO2　平均値</div>
          <div class="data-details-value">
            <span>{{ this.recordData?.data.spo2FingerAvg | number:'1.2-2' }}</span>
            <span>%</span>
          </div>
        </div>
        <div class="detail-items">
          <div class="data-details-title" i18n="@@home.vitalRecording.label.maxFingerSpo2">指先SpO2　最大値</div>
          <div class="data-details-value">
            <span>{{ this.recordData?.data.spo2FingerMax | number:'1.2-2' }}</span>
            <span>%</span>
          </div>
        </div>
        <div class="detail-items">
          <div class="data-details-title" i18n="@@home.vitalRecording.label.minFingerSpo2">指先SpO2　最小値</div>
          <div class="data-details-value">
            <span>{{ this.recordData?.data.spo2FingerMin | number:'1.2-2' }}</span>
            <span>%</span>
          </div>
        </div>
      </div>

      <div>
        <mat-divider></mat-divider>
        <div class="detail-area-bottom">
          <div>
            <div class="data-details-footer-title" i18n="@@home.vitalRecording.label.recordId">レコードID</div>
            <div class="data-details-footer-value">
              <span>{{ this.recordData?.id }}</span>
            </div>
          </div>
          <div>
            <div class="data-details-footer-title" i18n="@@home.vitalRecording.label.staff">スタッフ</div>
            <div class="data-details-footer-value">
              <span>{{ this.recordData?.meta.measurer.lastName }} {{ this.recordData?.meta.measurer.firstName }}</span>
            </div>
          </div>
          <div>
            <div class="data-details-footer-title" i18n="@@home.vitalRecording.label.section">セクション</div>
            <div class="data-details-footer-value">
              <span>{{ this.recordData?.meta.location.sectionName }}</span>
            </div>
          </div>
          <div>
            <div class="data-details-footer-title" i18n="@@home.vitalRecording.label.measurementDateTime">計測日時</div>
            <div class="data-details-footer-value">
              <!-- <span>{{ this.recordData?.data.createdAt }}</span> -->
              <span>{{ this.recordData.data.differentLocation ? (this.recordData?.data.createdAt | localDatetime) + '\n' + this.recordData?.data.createdAtLocationStr : (this.recordData?.data.createdAt | localDatetime) }}</span>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>

  </div>
</mat-card>
